// The renderer's text helpers: HTML escaping and its inverse, heading anchors, and the names a task list's
// checkboxes need. The Markdown itself is prose.ts's: CommonMark with GFM and the specification's inline forms.

export function escapeHtml(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/** The text escaped HTML stands for: the entities micromark and escapeHtml write, decoded. */
export function unescapeHtml(s: string): string {
  return s.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#x27;|&#39;/g, "'").replace(/&amp;/g, "&");
}

/** What a reader sees of some inline HTML, as text: not a pill's avatar or an embed's label (aria-hidden, a .sub caption). */
export function visibleText(html: string): string {
  return unescapeHtml(html.replace(/<span[^>]*aria-hidden="true"[^>]*>[^<]*<\/span>|<span class="sub">[^<]*<\/span>/g, "").replace(/<[^>]+>/g, ""));
}

/** Stable anchor for headings and named blocks. */
export function slug(text: string): string {
  return text.toLowerCase().replace(/<[^>]+>/g, "").replace(/&[a-z]+;/g, "").replace(/[^a-z0-9À-￿]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80) || "section";
}

export interface Heading { id: string; text: string; level: number }

/** A task list's checkbox is read-only and needs a name: its state, said (WCAG 4.1.2). */
export function taskLabels(html: string): string {
  return html.replace(/<input type="checkbox" disabled=""( checked="")? \/>/g, (_m, checked?: string) => `<input type="checkbox" disabled=""${checked ?? ""} aria-label="${checked ? "Done" : "Not done"}" />`);
}
